
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/history",
      function () {
        return require("private-next-pages/about-us/history.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/history"])
      });
    }
  